<template>
    <PhpEolLayout
        :supported-modules="supportedModules"
        :active-module="activeModule"
        @module-changed="changeModule"
    >
        <DRow
            align-horizontal="start"
            align-vertical="end"
            class="mb-3"
        >
            <DCol lg="2">
                <DInput
                    id="parent_id_search"
                    v-model="filterData.parent_id"
                    :label="__('tools.php_eol.first_email_candidates.filters.parent_contract_id')"
                    @keydown.enter.exact.prevent="loadPage(records.current_page, filterData)"
                />
            </DCol>
            <DCol lg="3">
                <DInput
                    id="domain_search"
                    v-model="filterData.domain"
                    :label="__('tools.php_eol.first_email_candidates.filters.domain')"
                    @keydown.enter.exact.prevent="loadPage(records.current_page, filterData)"
                />
            </DCol>
            <DCol lg="2">
                <DInput
                    id="batch_id_search"
                    v-model="filterData.batch_id"
                    type="number"
                    :label="__('tools.php_eol.first_email_candidates.filters.batch_id')"
                    @keydown.enter.exact.prevent="loadPage(records.current_page, filterData)"
                />
            </DCol>
            <DCol
                lg="3"
                class="d-flex gap-2"
            >
                <DButton
                    id="filter-apply"
                    :label="__('messages.actions.filter')"
                    @click="loadPage(records.current_page, filterData)"
                />
                <DButton
                    id="filter-reset"
                    icon="filter-off"
                    :label="__('messages.actions.reset_filter')"
                    @click="loadPage(records.current_page, {})"
                />
            </DCol>
        </DRow>
        <DRow>
            <DCard padding>
                <DTable
                    :items="props.records.data"
                    :fields="fields"
                    columnSorter
                    :tableProps="{
                        hover: true,
                    }"
                >
                    <template #parent_contract_id="{item}">
                        <td v-if="userPermissions.includes('contract.view')">
                            <Link :href="generateContractRoute(item.parent_contract.customer_id, item.parent_contract_id)">
                                {{ item.parent_contract_id }}
                            </Link>
                        </td>
                        <td v-else>
                            {{ item.parent_contract_id }}
                        </td>
                    </template>
                    <template #domain="{item}">
                        <td>
                            {{ item.domain }}
                        </td>
                    </template>
                    <template #status_label="{item}">
                        <td>
                            {{ item.status_label }}
                        </td>
                    </template>
                    <template #previous_status_label="{item}">
                        <td>
                            {{ item.previous_status_label }}
                        </td>
                    </template>
                    <template #batch_id="{item}">
                        <td>
                            {{ item.batch_id }}
                        </td>
                    </template>
                </DTable>
                <DPagination
                    v-if="records.last_page >= 1"
                    :active-page="records.current_page"
                    :pages="records.last_page"
                    align="center"
                    @update:activePage="(page) => loadPage (page, filterData)"
                />
            </DCard>
        </DRow>
    </PhpEolLayout>
</template>

<script setup>

import { router, usePage } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'
import { computed, ref } from 'vue'
import PhpEolLayout from '~@/Pages/Contracts/PhpEol/Layout.vue'
import { route } from '~@/Composables/route'

const props = defineProps({
    records: {
        type: Object,
        default: () => {
            return {}
        }
    },
    filters: {
        type: Object,
        default: () => {
            return {}
        }
    },
    indexRoute: {
        type: String,
        default: () => {
            return null
        }
    },
    supportedModules: {
        type: Array,
        default () {
            return []
        }
    },
    activeModule: {
        type: String,
        default () {
            return ''
        }
    }
})

const fields = computed(() => {
    return [
        { key: 'parent_contract_id', label: __('tools.php_eol.first_email_candidates.table.parent_contract_id') },
        { key: 'domain', label: __('tools.php_eol.first_email_candidates.table.domain') },
        { key: 'status_label', label: __('tools.php_eol.first_email_candidates.table.status') },
        { key: 'previous_status_label', label: __('tools.php_eol.first_email_candidates.table.previous_status') },
        { key: 'batch_id', label: __('tools.php_eol.first_email_candidates.table.batch') },
    ]
})

const userPermissions = computed(() => usePage().props.auth.permissions)
const filterData = ref(props.filters)

const generateContractRoute = function (customerId, contractId) {
    return route('customers.customers.contracts.show', { customer: customerId, contract: contractId })
}

const loadPage = function (page, queryParameters = {}) {
    if (page > 1) {
        queryParameters.page = page
    }

    queryParameters.module = props.activeModule
    router.get(route(props.indexRoute), queryParameters)
}

const changeModule = function (moduleName) {
    router.get(route('contracts.php-eol-bulk.index'), { module: moduleName })
}

</script>

<style lang="scss" scoped>
.header-actions {
    display: grid;
    justify-items: flex-start;
    gap: 10px;
}
</style>
